import Swiper from "@theme/swiper";
import { Navigation } from "@theme/swiper-modules";

export default class ProductGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiper = this.querySelector(".swiper"); // safer to query here
    this.initSwiper();
    this.handleMixedBackground();
  }

  initSwiper() {
    if (window.innerWidth < 1000) {
      this.swiper = new Swiper(this.swiper, {
        modules: [Navigation],
        slidesPerView: "auto",
        loop: false,
        speed: 1000,
        spaceBetween: 10,
        navigation: {
          prevEl: this.querySelector(".swiper-button-prev"),
          nextEl: this.querySelector(".swiper-button-next"),
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 1,
          },
        },
      });
    }
  }
  handleMixedBackground() {
    const mainProduct = document.querySelector(".main-product");
    const mixedBackground = document.querySelector(".mixed #mixed-background");
    if (!mainProduct || !mixedBackground) return;

    const updateBackgroundState = () => {
      const { bottom } = mainProduct.getBoundingClientRect();
      mixedBackground.classList.toggle("absolute!", bottom <= 0);
    };

    window.addEventListener("scroll", updateBackgroundState, { passive: true });
    updateBackgroundState();
  }
}

customElements.define("product-gallery", ProductGallery);
